export const isAuthenticated = () => {
    // Check if the token exists and is valid
    const token = localStorage.getItem("tokenData");
    return !!token; // Replace with actual token validation logic
};


export const getUserRole = () => {
    const userData = localStorage.getItem("userData");
    if (userData) {
      return JSON.parse(userData);
    }
    return null;
  };
  